export const getDocumentApi = (hostUrl?: string) => {
  if (!hostUrl) return;
  if (hostUrl.endsWith('/api/documents/api.js')) return hostUrl;
  return `${hostUrl}/web-apps/apps/api/documents/api.js`;
};
